import Seo from '../components/Seo';
import ScrollProgress from '../components/ScrollProgress';
import Hero from '../sections/Hero';
import SignalStrip from '../sections/SignalStrip';
import IntroSection from '../sections/IntroSection';
import ServicesSection from '../sections/ServicesSection';
import PlanningSection from '../sections/PlanningSection';
import ProcessSection from '../sections/ProcessSection';
import AssistantSection from '../sections/AssistantSection';
import GallerySection from '../sections/GallerySection';
import VideoSection from '../sections/VideoSection';
import AreaSection from '../sections/AreaSection';
import FaqSection from '../sections/FaqSection';
import ContactSection from '../sections/ContactSection';
import { businessSchema, homeFaqSchema } from '../data/seo';

function HomePage() {
  return (
    <>
      <Seo
        title="MH-BETON | Betonpumpe, Betontransport und Beton in Wien"
        description="MH-BETON koordiniert Betontransport, Betonverkauf und Betonpumpenvermietung mit Fahrer in Wien, Wien Umgebung und Niederösterreich. Direkt anrufen oder Anfrage starten."
        schema={[businessSchema, homeFaqSchema]}
      />
      <ScrollProgress />
      <Hero />
      <SignalStrip />
      <IntroSection />
      <ServicesSection />
      <PlanningSection />
      <ProcessSection />
      <AssistantSection />
      <GallerySection />
      <VideoSection />
      <AreaSection />
      <FaqSection />
      <ContactSection />
    </>
  );
}

export default HomePage;
